module.exports = __webpack_public_path__ + "static/media/ic-2.79432d9f.svg";